<script>
import Popup from "@/components/popup/Popup.vue";
import SearchBuild from "@/components/build/SearchBuild.vue";

export default {
  name: "LoadBuildModal",
  components: {SearchBuild, Popup},
  data() {
    return {
      buildUid: '',
    }
  },
  methods: {
    closePopup() {
      this.$emit('close');
    },
  }
}
</script>

<template>
  <Popup @codd_close="closePopup" size="small">
    <div class="wrapper">
      <span class="close-btn" @click="$emit('close')">&times;</span>
      <div>
        <div class="step-title">
          {{ $t('powerpack.steps.step1.open_build') }}
        </div>

        <search-build @close="closePopup"></search-build>
      </div>
    </div>
  </Popup>
</template>

<style scoped lang="scss">
.wrapper {
  padding: 20px 40px 20px 20px;
}

.close-btn {
  color: #A4AFB7;
  position: absolute;
  font-size: 30px;
  right: 12px;
  top: 0;
  cursor: pointer;
  transition: all ease 0.3s;

  &:hover {
    color: darken(#A4AFB7, 40%);
  }
}

.step-title {
  padding-bottom: 20px;
  font-size: 16px;
  font-family: neue-haas-grotesk-display, sans-serif;
  font-weight: 700;
  font-style: normal;
}
</style>